module.exports = __webpack_public_path__ + "static/media/zumba.afc9947c.jpg";